import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Form, Button, Row, Col, Carousel, Input, Select, message, Empty, Spin, Modal } from 'antd';
import { RightOutlined, LeftOutlined } from '@ant-design/icons';
import { STORAGE_CODE_LIST } from '../../common/manageOutsConstants';
import { useSearchSubstituteProducts, useResetSubstituteProducts,  } from './redux/hooks'
import { deleteOriginalItem, validateNumericRegExp } from './formattedSubsData'
import _ from 'lodash';
import { grouprecommendedProducts } from './ManageOutsAddSub';

export default function SearchRecommendedProducts(props) {
  const { onCancel, initialValues, onSelectSub, isDragable = false, form,title,callFrom,setDragedElementId } = props;
  const {
    substituteProducts,
    searchSubstituteProductsPending,
    recommendedProducts,
    fetchRecommendedProductsPending,
  } = useSelector(state => ({
    substituteProducts: state.manageSubs.substituteProducts,
    searchSubstituteProductsPending: state.manageSubs.searchSubstituteProductsPending,
    recommendedProducts: state.manageSubs.recommendedProducts,
    fetchRecommendedProductsPending: state.manageSubs.fetchRecommendedProductsPending,
  }));
  const { searchSubstituteProducts } = useSearchSubstituteProducts();
  const { resetSubstituteProducts } = useResetSubstituteProducts();
    const carouselSettings = {
    dots: false,
    arrows: true,
    infinite: false,
    swipe: false,
    swipeToSlide: false,
    touchMove: false,
    draggable: false,
    accessibility: false,
    prevArrow: <LeftOutlined />,
    nextArrow: <RightOutlined />
  };

  const onReset = () => {
    form.setFieldsValue({
      description: undefined,
      SUPC: undefined,
      pack: undefined,
      size: undefined,
      storage: undefined,
      brand: undefined,
    });
    resetSubstituteProducts();
  }
  const searchRecommendProduct=()=>{
    const inputInfo = {
      description: form.getFieldValue("description") ? form.getFieldValue("description").trim() : "",
      supc: form.getFieldValue("SUPC") ? form.getFieldValue("SUPC").trim() : "",
      pack: form.getFieldValue("pack") ? form.getFieldValue("pack").trim() : "",
      size: form.getFieldValue("size") ? form.getFieldValue("size").trim() : "",
      storage: form.getFieldValue("storage"),
      brand: form.getFieldValue("brand") ? form.getFieldValue("brand").trim() : "",
    }
    if (!inputInfo.description && !inputInfo.supc) {
      message.warning('Please input Description or SUPC!')
    } else {    
      const { site, originalUom, originalItem, nationalId, customerNumber, selectedUom} = form.getFieldValue();
      if (isDragable) {
        if (_.isEmpty(site) || _.isEmpty(originalUom) || _.isEmpty(originalItem) || !(!_.isEmpty(nationalId) || !_.isEmpty(customerNumber))) {
          message.warning('site/originalItem/nationalId/customerNumber  is invalid!');
          return;
        }
      }
      let params = {
        "site": [site],
        "originalItemUom": !_.isEmpty(selectedUom)? selectedUom: originalUom,
        "originalItem": originalItem,
        "nationalId": validateNumericRegExp(nationalId) ? '' : nationalId,
        "customerNumber": validateNumericRegExp(nationalId) ? nationalId : '',
        "isFromOuts": false,
        "totalOuts": 0,
        "searchFor": "Additional Search",
      }
      if (inputInfo.supc) {
        params["searchBy"] = "SUPC"
        params["searchInput"] = inputInfo.supc
      } else {
        params["searchBy"] = "Item Description"
        params["searchInput"] = inputInfo.description
      }
      if (inputInfo.pack) params['pack'] = inputInfo.pack
      if (inputInfo.size) params['size'] = inputInfo.size
      if (inputInfo.storage) params['storageCode'] = inputInfo.storage
      if (inputInfo.brand) params['brand'] = [inputInfo.brand]
      searchSubstituteProducts(params)
      .catch(err => {
        //message.error(`Search Substitutions Failed, please try again.`);
        message.error(`${err}`) //COT-10152
      });
    }
  }
  let searchResults = substituteProducts ?
    ((substituteProducts.data && substituteProducts.data.length) ? deleteOriginalItem(substituteProducts.data, initialValues.originalItem) : null) : null;
  let searchResultVisible = substituteProducts ?
    ((substituteProducts.data && substituteProducts.data.length) ? "results" : "no-results-found") : "no-search";

  const [dragRecommendedProducts, setDragRecommendProducts] = useState([]);
  useEffect(() => {
    setDragRecommendProducts( recommendedProducts?
      ((recommendedProducts?.data && recommendedProducts?.data.length) ? deleteOriginalItem(recommendedProducts?.data,initialValues.originalItem) : null): null);
  }, [recommendedProducts, initialValues]);
  return (
    <div className="manage-subs-search-recommended-products">
      
      <div className='prodcuts-title'>Recommended Products
        <span className='title-tips'>Click Sub button to add items to Substitution Table</span>
      </div>
      <Spin spinning={fetchRecommendedProductsPending}>
        <div className='carousel-panel'>
          {dragRecommendedProducts && dragRecommendedProducts.length > 0 ?
            <Carousel {...carouselSettings}>
              {grouprecommendedProducts(dragRecommendedProducts, 10, isDragable, onSelectSub, initialValues, setDragedElementId).map((item, index) =>
                <div className="carousel-slide-grid-scroll" key={index}>
                  <div className='grouped-product-card' style={{ marginBottom: 5 }}>
                    {item.slice(0, 5).map((it, index) => (it))}
                  </div>
                  <div className='grouped-product-card'>
                    {item.slice(5).map((it, index) => (it))}
                  </div>
                </div>
              )}
            </Carousel>
            :
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No Recommended Substitution found" />
          }
        </div>
      </Spin>
      
      <Spin spinning={searchSubstituteProductsPending}>
      <div className='prodcuts-title'> Additional Search</div>
            <Row>
        <Col span={8}>
          <Form.Item name="description">
            <Input placeholder="Description" />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="pack">
            <Input placeholder="Pack" />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Button htmlType="button" onClick={onReset} className="default-btn">
            Reset
          </Button>
        </Col>
      </Row>
      <Row>
        <Col span={8}>
          <Form.Item name="size">
            <Input placeholder="Size" />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="brand">
            <Input placeholder="Brand" />
          </Form.Item>
        </Col>
         <Col span={8} style={{marginTop:'20px'}}>
          <Button htmlType="button" onClick={searchRecommendProduct} type="primary" className="primary-btn" 
          disabled={searchSubstituteProductsPending}>
            Search
          </Button>
        </Col>
      </Row>
      <Row>
        <Col span={8}>
          <Form.Item name="storage">
            <Select
              mode="multiple"
              allowClear
              maxTagCount={1}
              placeholder="Storage"
            >
              {STORAGE_CODE_LIST.map(item => {
                return (
                  <Select.Option key={item.label} value={item.label}>
                    {item.value}
                  </Select.Option>
                );
              })}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="SUPC">
            <Input placeholder="SUPC" />
          </Form.Item>
        </Col>
      </Row>
      <div className='additional-search'>
      {searchResultVisible === "results" && (
        <><div className="prodcuts-title" style={{ marginTop: 10 }}>
        Results
      </div>
        <div className='search-prodcut'>
          
          {/* <Spin spinning={searchSubstituteProductsPending}> */}
            {searchResults && searchResults.length > 0 && (
                  <Carousel {...carouselSettings}>
                    {grouprecommendedProducts(searchResults, 10, isDragable, onSelectSub, initialValues, setDragedElementId).map((item, index) =>
                      <div className="carousel-slide-grid-scroll" key={index}>
                        <div className='grouped-product-card' style={{ marginBottom: 5 }}>
                          {item.slice(0, 5).map((it, index) => (it))}
                        </div>
                        <div className='grouped-product-card'>
                          {item.slice(5).map((it, index) => (it))}
                        </div>
                      </div>
                    )}
                  </Carousel>)
            }
          {/* </Spin> */}
        </div></>
      )}
      </div>
      {searchResultVisible === "no-results-found" && (
        <Spin spinning={searchSubstituteProductsPending}>
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No Results found" />
        </Spin>
      )}
      </Spin>
    </div>
  );
};

SearchRecommendedProducts.propTypes = {};
SearchRecommendedProducts.defaultProps = {};


